import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { LocalStorageService } from '../services/storage/local-storage.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const localStorage = inject(LocalStorageService);
  const loggedIn = !!localStorage.get('token');

  if (!loggedIn) {
    router.navigate(['/login.html'], {
      queryParams: { redirectTo: state.url },
    });
  }
  return loggedIn;
};
